<template>
  <layout-default-app-bar filterable :filters="filters">
    Controle Armazenamento
  </layout-default-app-bar>
</template>

<script>
import { CONTROLE_ARMAZENAMENTO_QUERIES } from '@/constants/QUERY_FILTERS';
import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ControleArmazenamentoAppBar',

  components: {
    LayoutDefaultAppBar,
  },

  data() {
    return {
      filters: [
        CONTROLE_ARMAZENAMENTO_QUERIES.createdFrom,
        CONTROLE_ARMAZENAMENTO_QUERIES.createdBefore,
      ],
    };
  },
};
</script>
